module.exports = __webpack_public_path__ + "media/img/favicon/mstile-70x70-9ea50c5e0a6fd64a8ac62e1f324cab0e.png";